export const FETCH_OPTIONS: RequestInit = {
  headers: { Accept: 'application/json' },
  mode: 'cors',
  credentials: 'include',
};
